import { ArrowRightLeft } from "lucide-react";
import { formatClockTime } from "@/lib/api";

/**
 * Renders the handoff history for an order.
 * Returns null if there are no handoffs.
 *
 * Props:
 *  - history: Array<{from_name, to_name, at}>
 *  - testIdPrefix: string
 *  - tone: "card" | "table" — controls visual density
 */
export function HandoffHistory({ history, testIdPrefix, tone = "card" }) {
  const entries = Array.isArray(history) ? history.filter(Boolean) : [];
  if (entries.length === 0) return null;

  if (tone === "table") {
    // dense inline view used in reports
    return (
      <div data-testid={`${testIdPrefix}-handoff`} className="font-mono text-[10px] text-zinc-700 leading-snug">
        {entries.map((h, i) => (
          <div key={i} data-testid={`${testIdPrefix}-handoff-row-${i}`} className="flex items-center gap-1">
            <ArrowRightLeft size={10} strokeWidth={2.5} className="text-violet-700 shrink-0" />
            <span className="break-words">{h.from_name} → {h.to_name}</span>
            <span className="text-zinc-400">·</span>
            <span>{formatClockTime(h.at)}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      data-testid={`${testIdPrefix}-handoff`}
      className="mt-3 border-2 border-violet-300 bg-violet-50 px-3 py-2"
    >
      <div className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-violet-900 mb-1.5">
        <ArrowRightLeft size={11} strokeWidth={2.5} />
        Devir / Geri Bırakma Geçmişi
        <span className="ml-auto inline-flex items-center justify-center min-w-[18px] h-4 px-1 bg-violet-900 text-white text-[10px] font-bold">
          {entries.length}
        </span>
      </div>
      <ul className="space-y-1">
        {entries.map((h, i) => {
          const isRelease = h.type === "release";
          return (
            <li
              key={i}
              data-testid={`${testIdPrefix}-handoff-row-${i}`}
              className="flex items-center gap-2 text-[13px] text-zinc-900"
            >
              <span className="font-bold">{h.from_name}</span>
              <ArrowRightLeft size={12} strokeWidth={2.5} className={isRelease ? "text-amber-700" : "text-violet-700"} />
              <span className={`font-bold ${isRelease ? "text-amber-800 italic" : ""}`}>{h.to_name}</span>
              <span className="ml-auto font-mono text-[11px] text-violet-800">{formatClockTime(h.at)}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
